var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9916 8.65904C16.9916 7.96256 16.9338 7.45431 16.8086 6.92725H8.66992V10.0708H13.4472C13.3509 10.852 12.8308 12.0285 11.675 12.8191L11.6588 12.9243L14.2321 14.8724L14.4103 14.8898C16.0477 13.4121 16.9916 11.2379 16.9916 8.65904Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66765 16.9415C11.0081 16.9415 12.9729 16.1885 14.4081 14.8896L11.6727 12.819C10.9407 13.3178 9.95826 13.666 8.66765 13.666C6.37535 13.666 4.42978 12.1884 3.73624 10.146L3.63458 10.1544L0.958821 12.178L0.923828 12.2731C2.34929 15.0402 5.2773 16.9415 8.66765 16.9415Z",
    fill: "#62A74A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73702 10.146C3.55403 9.61891 3.44812 9.05415 3.44812 8.47064C3.44812 7.88706 3.55403 7.32236 3.7274 6.79529L3.72255 6.68304L1.01325 4.62695L0.924612 4.66816C0.33711 5.81643 0 7.1059 0 8.47064C0 9.83537 0.33711 11.1248 0.924612 12.2731L3.73702 10.146Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66766 3.27535C10.2954 3.27535 11.3934 3.96243 12.0194 4.5366L14.4659 2.20241C12.9634 0.837672 11.0081 0 8.66766 0C5.2773 0 2.34929 1.90121 0.923828 4.66832L3.72661 6.79546C4.42978 4.75306 6.37535 3.27535 8.66766 3.27535Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.4d9d6c40e16cc16241ddfcf099463d40.svg";
export { ForwardRef as ReactComponent };